import { Directive } from '@angular/core';

/**
 * Adds properties and events to drag handle elements
 */
@Directive({ selector: '[ngxDragHandle]' })
export class DragHandleDirective {}
